//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import tabs from '~/components/common/tabs'
// import mobileTab from '~/components/common/mobileTab'
import mobileTab from '~/components/data/mobileTab.vue'
import { assign, getToday, matomofn } from '~/assets/js/utils.js'
import breadCrumbs from '~/components/common/breadCrumbs.vue'

export default {
  components: {
    tabs,
    mobileTab,
    'bread-crumbs': breadCrumbs
  },
  async asyncData ({ $api, store, route, error }) {
    const { locale = 'en' } = store.state
    try {
      // let trendForPriceTime = '' // 更新时间
      // $api.common.invokeServer({ HttpMethod: 'post', Route: '/mt4Extend/trendForPrice' }, { symbol: 'EURUSD', num: 3, startTime: getAppointNDay('', 3), endTime: getSeconds(), apiLanguage: locale }).then((res) => {
      //   if (res?.trendForPrice?.length) {
      //     trendForPriceTime = res?.trendForPrice[0]?.create_at.split(' ')[0]
      //   } else {
      //     trendForPriceTime = getToday()
      //   }
      // })
      const trendForPriceTime = getToday()
      let pageSize = 12
      if (!['zh-cn', 'zh'].includes(locale)) pageSize = 9
      const rakingData = await $api.burstData.newRakingService({
        period: 2,
        sort: 0,
        code: locale,
        pageindex: 1,
        account_type: 1, // 1为所有账户，2为ECN，3为Standard
        vps_area: 1,
        pagesize: pageSize
      })
      const brokersData = await $api.burstData.newBrokersService({})
      console.log(brokersData, '对比交易商数据')
      const total = rakingData?.total // 查看更多是否显示
      brokersData?.forEach((item) => { // 对比列表默认都是为没选中
        item.isChecked = false
      })
      // 时间戳转时间
      rakingData.day_time = getToday((rakingData?.day_time + '000') - 0)
      rakingData?.data?.forEach((item) => { // 交易商列表默认都是未选中
        item.isChecked = false
      })
      return { rakingData, brokersData, total, pageSize, trendForPriceTime }
    } catch (error) {}
  },
  data () {
    return {
      trendForPriceTime: '', // 更新时间
      fotterHeight: 0, // 底部的高低
      bottomBtnFix: true, // 屏幕宽度为1000以下的时候底部按钮是否固定定位
      isFixed: false, // 判断右边框是否固定定位
      checkedArr: [], // 选中的数组
      total: 0, // 总条数
      pageNum: 1, // 当前页数
      pageSize: 12, // 一页展示多少条数据
      isShow: false, // 对比的交易商列表默认不显示
      isTabClcik: 0, // 防止tab重复点击
      pageEnterTime: null, // 页面进入时间
      allTabList: [ // 顶层tab
        {
          name: this.$t('61998'),
          code: 0
        },
        {
          name: 'ECN',
          code: 1
        },
        {
          name: 'Standard',
          code: 2
        }
      ],
      curAllIdx: 0, // 当前父级选中项
      isAllIdx: 0, // 防止重复点击
      tabName: [ // tab数据
        { name: 'TYY_000291', code: 0, isSelect: false, selectList: [] },
        {
          name: '12758',
          code: 1,
          isSelect: true,
          selectList: [
            { name: '61999', code: 1, icon: require('@/assets/img/vps/global.svg') },
            { name: 'TYY_000433', code: 2, icon: require('@/assets/img/vps/china.png') },
            { name: '24448', code: 3, icon: require('@/assets/img/vps/hongkong.svg') },
            { name: 'CLD_000050', code: 4, icon: require('@/assets/img/vps/th-bkk.png') },
            { name: '17955', code: 5, icon: require('@/assets/img/vps/eu-frankfurt.jpg') }
          ]
        },
        { name: '12759', code: 2, isSelect: false, selectList: [] },
        { name: '12760', code: 3, isSelect: false, selectList: [] },
        { name: '12761', code: 4, isSelect: false, selectList: [] }
      ],
      tabIndex: 0, // 当前tab选中的下标
      selectObj: { name: '61999', code: 0, icon: require('@/assets/img/vps/global.svg') },
      areaType: 0, // 默认选中国家
      rakingData: { data: [], day_time: '', total: [], total_traders: 0, total_count: 0, total_banlances: 0 }, // 页面左侧交易商数据
      brokersData: [] // 页面右侧选择对比交易商
    }
  },
  head () {
    return {
      title: this.$t('19808'),
      meta: [
        { name: 'Keywords', content: this.$t('TYY_000667') },
        { name: 'Description', content: this.$t('19809') }
      ]
    }
  },
  computed: {
    // 当前屏幕的宽度
    screenWidth () {
      return this.$store.state?.screenWidth || 0
    }
  },
  created () {
    if (!this.rakingData) this.rakingData = { data: [], day_time: '', total: [], total_traders: 0, total_count: 0, total_banlances: 0 }
    if (!this.rakingData?.data?.length) assign(this.rakingData, { data: [] })
  },
  mounted () {
    // 记录页面进入时间
    this.pageEnterTime = Date.now()
    // 添加页面离开监听
    window?.addEventListener('beforeunload', this.trackPageTime)

    window?.addEventListener('scroll', this.scrollFn)
    this.$nextTick(() => {
      this.fotterHeight = document.getElementsByClassName('fx-footer-view')[0].getBoundingClientRect().height
      this.processingList() // 不同的宽度初始化获取不同的列表数据条数
    })
  },
  beforeDestroy () {
    window?.removeEventListener('scroll', this.scrollFn)
    // 移除事件监听器
    window?.removeEventListener('beforeunload', this.trackPageTime)
    // 执行页面时间统计
    this.trackPageTime()
  },
  methods: {
    // 页面时间统计
    trackPageTime () {
      if (this.pageEnterTime) {
        const exitTime = Date.now()
        matomofn('Cloud_Environment_Time', {
          af_Enter: this.pageEnterTime,
          af_Exit: exitTime
        }, this.$store.state, this.$cookies)
      }
    },
    showText (text) {
      if (text == 'Perfect' || text == 'Poor') return true
      else return false
    },
    mobileTab (item) {
      this.areaType = item.area
      this.checkedFn('', 2) // 对比数组清空
      this.pageNum = 1 // 当前页重置为1
      this.getList(this.tabIndex)
    },
    // 不同的宽度初始化获取不同的列表数据条数
    processingList () {
      if (this.screenWidth < 1200 && this.screenWidth > 799 && this.isChinese()) {
        this.pageSize = 9
        if (this.rakingData?.data?.length > 9) {
          this.rakingData.data = this.rakingData?.data?.slice(0, 9)
        }
      }
      if (this.screenWidth < 1200 && this.screenWidth > 799 && !this.isChinese()) {
        this.pageSize = 6
        if (this.rakingData?.data?.length > 6) {
          this.rakingData.data = this.rakingData?.data?.slice(0, 6)
        }
      }
    },
    tabFn (item) {
      const arr = this.$refs.mobileArr
      arr.forEach((x, idx) => {
        if (!item.isSelect) {
          x.downShow = false
        }
      })
      this.pageNum = 1 // 当前页重置为1
      this.tabClick(item.code)
    },
    changeTab (item) {
      if (this.isAllIdx == item.code) return // 防止当前选中tab重复点击
      this.checkedFn('', 2) // 对比数组清空
      this.pageNum = 1 // 当前页重置为1
      this.curAllIdx = item.code
      this.isAllIdx = item.code
      this.getList(this.tabIndex)
    },
    // 16进制颜色转换rgba
    olorRgb (color, type = 0) {
      if (!color) return false
      const reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/
      let sColor = color.toLowerCase()
      if (sColor && reg.test(sColor)) {
        if (sColor.length === 4) {
          let sColorNew = '#'
          for (let i = 1; i < 4; i += 1) {
            sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1))
          }
          sColor = sColorNew
        }
        // 处理六位的颜色值
        const sColorChange = []
        for (let i = 1; i < 7; i += 2) {
          sColorChange.push(parseInt('0x' + sColor.slice(i, i + 2)))
        }
        if (type == 0) return 'rgba(' + sColorChange.join(',') + ')'
        else if (type == 1) return 'rgba(' + sColorChange.join(',') + ',.2' + ')'
        else if (type == 2) return 'rgba(' + sColorChange.join(',') + ',.1' + ')'
      } else {
        return sColor
      }
    },
    // 获取颜色
    getColor (text) {
      if (!text) return false
      return [this.olorRgb(this.rakingData?.data[0]?.color[text], 0), this.olorRgb(this.rakingData?.data[0]?.color[text], 1), this.olorRgb(this.rakingData?.data[0]?.color[text], 2)]
    },
    // 跳转至详情页
    toDetails (id = '') {
      this.$cookies.set('rankObj', JSON.stringify({ areaType: this.areaType + 1, account_type: this.curAllIdx + 1 }))
      window?.open(`/${this.currLangCode()}/data/broker/${id}.html`)
    },
    scrollFn () {
      // 滚动高度
      const scrollTop = document?.documentElement?.scrollTop || window?.pageYOffset || document?.body?.scrollTop
      this.isFixed = (scrollTop > 230)
      // 可视区高度
      const browserHeight = window?.innerHeight || document?.documentElement?.clientHeight || document?.body?.clientHeight
      // 页面总高度
      const scrollHeight = document?.documentElement?.scrollHeight || document?.body?.scrollHeight
      // 总高度-可视区高度-底部高度
      const newScrollHeight = scrollHeight - browserHeight - this.fotterHeight - 66
      if (scrollTop >= newScrollHeight) this.bottomBtnFix = false
      else this.bottomBtnFix = true
    },
    // 点击开始对比
    contrast () {
      if (this.checkedArr?.length < 2) return this.$toast.info(this.$t('19286'))
      matomofn('Cloud_Environment_Compare', { }, this.$store.state, this.$cookies)
      // 获取选中的交易商id
      const str = this.checkedArr?.map(item => item.broker_id)?.join(',')
      this.$cookies.set('brokerIds', str)
      window?.open(`/${this.currLangCode()}/data/EnvContrast.html`)
    },
    // 添加选中的数据
    checkedFn (code, num = 0) {
      // num等于0是添加1是取消
      if (num == 0) {
        // 最多只有5个交易商对比
        if (this.checkedArr?.length == 5) return this.$toast.info(this.$t('19287'))
        // 把交易商列表当前选中的状态改一下（isChecked）
        this.rakingData?.data?.forEach((item) => {
          if (item.broker_id == code) item.isChecked = true
        })
        // 把对比列表当前选中的状态改一下（isChecked）
        this.brokersData?.forEach((item) => {
          if (item.broker_id == code) {
            item.isChecked = true
            this.checkedArr.push(item)
          }
        })
        // 取消选中进入
      } else if (num == 1) {
        // 获取到当前取消的小标
        const index = this.checkedArr?.findIndex(item => item.broker_id == code)
        // 删除index项的交易商
        this.checkedArr?.splice(index, 1)
        // 把对应的交易商列表选中状态改为false
        this.rakingData?.data?.forEach((item) => {
          if (item.broker_id == code) item.isChecked = false
        })
        // 把对应的对比列表选中状态改为false
        this.brokersData?.forEach((item) => {
          if (item.broker_id == code) item.isChecked = false
        })
        // 清除对比数组进入
      } else {
        // 清空对比数组将所有的选中状态改为false
        this.checkedArr = []
        this.rakingData?.data?.forEach((item) => {
          item.isChecked = false
        })
        this.brokersData?.forEach((item) => {
          item.isChecked = false
        })
      }
    },
    // 点击查看更多
    more () {
      this.pageNum++ // 当前页+1
      this.getList(this.tabIndex, 1)
    },
    // tab的点击事件
    tabClick (index) {
      if (this.isTabClcik == index) return // 防止当前选中tab重复点击
      this.checkedFn('', 2) // 对比数组清空
      this.tabIndex = index // 存储当前选中的tab index
      this.isTabClcik = index
      this.pageNum = 1 // 当前页重置为1
      this.getList(index)
    },
    // 获取列表数据
    async getList (index, type = 0) {
      const rakingData = await this.$api.burstData.newRakingClient({
        period: 2,
        sort: index,
        account_type: this.curAllIdx + 1, // 1为所有账户，2为ECN，3为Standard
        vps_area: this.areaType + 1,
        pageindex: this.pageNum,
        pagesize: this.pageSize
      })
      // 判断是否有更多数据
      this.total = rakingData?.total
      rakingData?.data?.forEach((item) => {
        item.isChecked = false // 默认全部都不被选中
      })
      if (type == 0) { // type为0时是点击tab获取数据，为1时时点击查看更多
        rakingData.day_time = getToday((rakingData.day_time + '000') - 0)
        this.rakingData = rakingData
      } else {
        this.rakingData?.data?.push(...rakingData?.data)
      }
      this.bottomBtnFix = true
    }
  }
}
